//-- Process
export const SET_POSTION_PRODUCTS = 'SET_POSTION_PRODUCTS';

//-- XHR receiving datas
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const RESET_PRODUCT_LIST = 'RESET_PRODUCT_LIST';

//-- ERRORS
export const CLEAN_ERROR_PRODUCTS = 'CLEAN_ERROR_PRODUCTS';
export const ERROR_PRODUCTS = 'ERROR_PRODUCTS';


// WEBPACK FOOTER //
// ./src/components/StorePage/StoreActionTypes.js